import React, { useEffect, useState } from "react";
import Page from "../../component/Page";
import { getBranchList, getCatalogList } from "../setting/services/settingApi";
import api from "../../api/api";
import { saveAs } from "file-saver";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Menu,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { REPORT_CONFIG } from "./config";
import { MobileDatePicker } from "@mui/x-date-pickers";
const BrowserInput = function BrowserInput(props) {
  const {
    inputProps,
    InputProps,
    ownerState,
    value,
    inputRef,
    error,
    ...other
  } = props;
  return (
    <TextField
      {...inputProps}
      ref={inputRef}
      value={
        value
          ? value.substring(0, value?.length - 6) +
            (parseInt(value?.substring(value?.length - 6)) + 543).toString()
          : null
      }
      {...other}
      variant="standard"
      fullWidth
      InputProps={{
        disableUnderline: true,
      }}
    />
  );
};
export default function ReportAgent() {
  const [branchs, setBranchs] = useState([]);
  const [BranchNo, setBranchsNo] = useState("");
  const [Channel, setChannel] = useState("");
  const [startDate, setStartDate] = useState(
    dayjs(new Date()).subtract(1, "day")
  );
  const [endDate, setEndDate] = useState(dayjs(new Date()));
  const [reports, setReports] = useState([]);

  const { profile } = useSelector((state) => state.profile);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loadingDownload, setloadingDownload] = useState(false);
  const [loading, setloading] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    getBranchList(null, setBranchs);
    LoadReport();
  }, []);
  async function getAgentReport(body, mode, format) {
    const url = `${REPORT_CONFIG.requests.getAgentReport.url}/${mode}`;

    let _params = "";
    let _sdate = "";
    let _edate = "";
    let _channel = "";

    let _branchNo = "";
    let _format = "";

    if (body.sdate) {
      _sdate = "sdate=" + body.sdate;
    }
    if (body.edate) {
      _edate = "&edate=" + body.edate;
    }
    if (body.branchNo) {
      _branchNo = "&branchNo=" + (body.branchNo !== "-" ? body.branchNo : "");
    }
    if (body.channel) {
      _channel = "&channel=" + (body.channel !== "-" ? body.channel : "");
    }

    if (format) {
      _format = "&format=" + format;
    }
    _params = "?" + _sdate + _edate + _branchNo + _channel + _format;
    if (mode === "file") {
      setloadingDownload(true);
      const res = await api.get(url + _params, { responseType: "arraybuffer" });
      const data = res.data;
      if (format) {
        const blob = new Blob([data], { type: "application/pdf" });
        saveAs(blob, "ทะเบียนรายชื่อตัวแทนจำหน่ายเมล็ดพันธุ์พืช (กมข-40407)");
      } else {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "ทะเบียนรายชื่อตัวแทนจำหน่ายเมล็ดพันธุ์พืช (กมข-40407)");
      }
      setloadingDownload(false);
    } else {
      setloading(true);
      const res = await api.get(url + _params);
      const data = res.data.result;
      setReports(data);
      setloading(false);
    }
  }
  async function LoadReport() {
    const body = {
      sdate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : "",
      edate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : "",
      branchNo: BranchNo || undefined,
      channel: Channel || undefined,
    };
    getAgentReport(body, "data");
  }
  return (
    <div style={{ padding: "10px 30px" }}>
      <Page>
        <div class="container-fluid p-0">
          <form>
            <div class="row  no-gutters">
              <div class="col-12 col-lg-2">
                <div class="row no-gutters">
                  <div class="col-12 header-row border-1 ">ตัวกรอง</div>
                </div>
                <div class="row no-gutters p-2 border-1">
                  {profile?.BranchNo?.BranchNo === "00" && (
                    <div class="col-12">
                      <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                      <Box
                        className="backgroundField"
                        sx={{ marginBottom: "10px" }}
                      >
                        <FormControl variant="standard" fullWidth>
                          <Select
                            value={BranchNo || "-"}
                            onChange={(e) => setBranchsNo(e.target.value)}
                            disableUnderline
                          >
                            <MenuItem value="-">-</MenuItem>
                            {branchs?.map((x) => (
                              <MenuItem value={x?.BranchNo}>
                                {x?.BranchName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </div>
                  )}
                  <div class="col-12">
                    <label class="labelInput">วันที่เริ่มต้น</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "20px", borderRadius: "25px" }}
                    >
                      <MobileDatePicker
                        dayOfWeekFormatter={(day) => `${day}`}
                        value={startDate}
                        onChange={(e) => setStartDate(e)}
                        slotProps={{
                          textField: {
                            variant: "standard",
                            fullWidth: true,
                            InputProps: { disableUnderline: true },
                            value: startDate,
                          },
                        }}
                        slots={{
                          textField: BrowserInput,
                        }}
                      />
                    </Box>
                  </div>
                  <div class="col-12">
                    <label class="labelInput">วันที่สิ้นสุด</label>

                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "20px", borderRadius: "25px" }}
                    >
                      <MobileDatePicker
                        dayOfWeekFormatter={(day) => `${day}`}
                        value={endDate}
                        onChange={(e) => setEndDate(e)}
                        slotProps={{
                          textField: {
                            variant: "standard",
                            fullWidth: true,
                            InputProps: { disableUnderline: true },
                            value: endDate,
                          },
                        }}
                        slots={{
                          textField: BrowserInput,
                        }}
                      />
                    </Box>
                  </div>
                  <div class="col-12">
                    <label class="labelInput">ช่องทาง</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <FormControl variant="standard" fullWidth>
                        <Select
                          value={Channel || "-"}
                          onChange={(e) => setChannel(e.target.value)}
                          disableUnderline
                        >
                          <MenuItem value="-">-</MenuItem>
                          <MenuItem value="walk-in">walk-in</MenuItem>
                          <MenuItem value="e-service">e-service</MenuItem>
                         
                        </Select>
                      </FormControl>
                    </Box>
                  </div>

                  <div class="col-12">
                    <Button
                      onClick={LoadReport}
                      disabled={loading ? true : false}
                      variant="contained"
                      className="ButtomSearch"
                    >
                      {loading ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ค้นหา"
                      )}{" "}
                    </Button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <div class="row no-gutters">
                  <div class="col-12 d-flex justify-content-between header-row border-1 ">
                    <div>
                      ทะเบียนรายชื่อตัวแทนจำหน่ายเมล็ดพันธุ์พืช (กมข-40407)
                    </div>
                    <Button
                      variant="contained"
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      disabled={loadingDownload ? true : false}
                      onClick={handleClick}
                    >
                      {loadingDownload ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ดาวน์โหลด"
                      )}
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                      PaperProps={{
                        style: {
                          width: 100,
                        },
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          const body = {
                            sdate: startDate
                              ? dayjs(startDate).format("YYYY-MM-DD")
                              : "",
                            edate: endDate
                              ? dayjs(endDate).format("YYYY-MM-DD")
                              : "",
                            branchNo: BranchNo || undefined,
                          };
                          // setFormat('')
                          getAgentReport(body, "file");

                          handleClose();
                        }}
                      >
                        Excel
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          const body = {
                            sdate: startDate
                              ? dayjs(startDate).format("YYYY-MM-DD")
                              : "",
                            edate: endDate
                              ? dayjs(endDate).format("YYYY-MM-DD")
                              : "",
                            branchNo: BranchNo || undefined,
                          };
                          // setFormat('pdf')
                          getAgentReport(body, "file", "pdf");

                          handleClose();
                        }}
                      >
                        Pdf
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
                <div class="row no-gutters border-1 pt-3">
                  <div class="report col-12">
                    <div class="table-responsive-sm" style={{ height: "auto" }}>
                      <table class="table table-bordered table-sm table-hover">
                        <thead class="sticky-thead">
                          <tr>
                            <th scope="col">ลำดับ</th>
                            <th scope="col">ทะบียนตัวแทน</th>
                            <th scope="col">ชื่อผู้ดำเนินกิจการ</th>
                            <th scope="col">ชื่อร้าน</th>
                            <th scope="col">โทรศัพท์</th>
                            <th scope="col">บ้านเลขที่</th>
                            <th scope="col">หมู่ที่</th>
                            <th scope="col">ตำบล</th>
                            <th scope="col">อำเภอ</th>
                            <th scope="col">จังหวัด</th>
                            <th scope="col">รหัสไปรษณีย์</th>
                            <th scope="col">
                              ขึ้นทะเบียนกับศูนย์เมล็ดพันธุ์ข้าว
                            </th>
                            <th scope="col">
                              ต่อทะเบียนกับศูนย์เมล็ดพันธุ์ข้าว
                            </th>
                            <th scope="col">วันที่ทำรายการ</th>
                            <th scope="col">วันที่อนุมัติ</th>
                            <th scope="col">หมดอายุวันที่</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reports?.map((report, i) => (
                            <tr class="cp">
                              <td>{i + 1}</td>
                              <td class="text-center">{report?.AgentNumber}</td>
                              <td class="text-center">{report?.OwnerName}</td>
                              <td class="text-center">{report?.ContactName}</td>
                              <td class="text-center">{report?.Tel}</td>
                              <td class="text-center">{report?.HouseNumber}</td>
                              <td class="text-center">{report?.Moo}</td>
                              <td class="text-center">{report?.SubDistrict}</td>
                              <td class="text-center">{report?.District}</td>
                              <td class="text-center">{report?.Province}</td>
                              <td class="text-center">{report?.Zipcode}</td>
                              <td class="text-center">
                                {report?.RegisterAtBranch}
                              </td>
                              <td class="text-center">
                                {report?.ExtentionAtBranch}
                              </td>
                              <td class="text-center">
                                {report?.ModifiedDate}
                              </td>
                              <td class="text-center">{report?.ApproveDate}</td>
                              <td class="text-center">{report?.ExpireDate}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {reports.length === 0 && (
                  <div class="row">
                    <div class="col-12">
                      <div class="not-found">ไม่พบข้อมูล</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </Page>
    </div>
  );
}
